function ConvergenceIcon({ style, ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="2 5 20 16"
            fill="currentColor"
            style={{ ...style, width: '1em', height: '1em' }}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.29289 3.29289C6.68342 2.90237 7.31658 2.90237 7.70711 3.29289L11.7071 7.29289C12.0976 7.68342 12.0976 8.31658 11.7071 8.70711C11.3166 9.09763 10.6834 9.09763 10.2929 8.70711L8 6.41421V20C8 20.5523 7.55228 21 7 21C6.44772 21 6 20.5523 6 20V6.41421L3.70711 8.70711C3.31658 9.09763 2.68342 9.09763 2.29289 8.70711C1.90237 8.31658 1.90237 7.68342 2.29289 7.29289L6.29289 3.29289ZM16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289L21.7071 12.2929C22.0976 12.6834 22.0976 13.3166 21.7071 13.7071C21.3166 14.0976 20.6834 14.0976 20.2929 13.7071L18 11.4142V20C18 20.5523 17.5523 21 17 21C16.4477 21 16 20.5523 16 20V11.4142L13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071C11.9024 13.3166 11.9024 12.6834 12.2929 12.2929L16.2929 8.29289Z"
            />
        </svg>
    );
}

export default ConvergenceIcon;
